import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Btn, Confirm, Empty } from "@/pages/admin/managers/ui";
import { fmtTime } from "@/lib/api";
import { Trash2, Phone, Mail } from "lucide-react";

const STATUSES = ["Solicitud recibida", "Pendiente de depósito", "Confirmada", "Completada", "Cancelada"];
const COLORS = {
  "Solicitud recibida": "bg-blue-500/15 text-blue-300",
  "Pendiente de depósito": "bg-amber-500/15 text-amber-300",
  "Confirmada": "bg-emerald-500/15 text-emerald-300",
  "Completada": "bg-[#C5A059]/15 text-[#E5C887]",
  "Cancelada": "bg-red-500/15 text-red-300",
};

export default function BookingsManager() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const [confirmId, setConfirmId] = useState(null);

  const load = async () => {
    const q = filter ? `?status=${encodeURIComponent(filter)}` : "";
    setItems((await api.get(`/admin/bookings${q}`)).data);
  };
  useEffect(() => { load(); }, [filter]);

  const setStatus = async (id, status) => {
    try { await api.put(`/admin/bookings/${id}`, { status }); toast.success("Estado actualizado."); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const del = async () => { await api.delete(`/admin/bookings/${confirmId}`); toast.success("Reserva eliminada."); setConfirmId(null); load(); };

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-6">
        <button onClick={() => setFilter("")} className={`px-3 py-1.5 rounded-md text-xs ${!filter ? "bg-[#C5A059] text-[#0A0A0A]" : "bg-[#18181B] border border-[#27272A] text-[#A1A1AA]"}`}>Todas</button>
        {STATUSES.map((s) => (
          <button key={s} data-testid={`booking-filter-${s}`} onClick={() => setFilter(s)} className={`px-3 py-1.5 rounded-md text-xs ${filter === s ? "bg-[#C5A059] text-[#0A0A0A]" : "bg-[#18181B] border border-[#27272A] text-[#A1A1AA]"}`}>{s}</button>
        ))}
      </div>
      {items.length === 0 ? <Empty>No hay reservaciones.</Empty> : (
        <div className="space-y-3">
          {items.map((b) => (
            <div key={b.id} data-testid={`booking-row-${b.id}`} className="bg-[#18181B] border border-[#27272A] rounded-lg p-5">
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <p className="text-white font-medium text-lg">{b.full_name}</p>
                  <p className="text-sm text-[#8C8375]">{b.session_type} · {b.package_name || "Sin paquete"} · {b.num_people} persona(s)</p>
                  <div className="flex flex-wrap gap-4 mt-2 text-xs text-[#A1A1AA]">
                    <span className="flex items-center gap-1"><Phone size={12} /> {b.phone}</span>
                    <span className="flex items-center gap-1"><Mail size={12} /> {b.email}</span>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-mono text-sm text-[#C5A059]">{b.date}</p>
                  <p className="font-mono text-sm text-white">{fmtTime(b.time_slot)}</p>
                  {b.location && <p className="text-xs text-[#8C8375] mt-1">{b.location}</p>}
                </div>
              </div>
              {b.comments && <p className="mt-3 text-sm text-[#A1A1AA] bg-[#0F0F10] rounded p-3">{b.comments}</p>}
              <div className="flex flex-wrap items-center gap-2 mt-4">
                <span className={`text-xs px-3 py-1 rounded-full ${COLORS[b.status]}`}>{b.status}</span>
                <select
                  data-testid={`booking-status-${b.id}`}
                  value={b.status}
                  onChange={(e) => setStatus(b.id, e.target.value)}
                  className="bg-[#0F0F10] border border-[#27272A] rounded-md text-xs text-white px-2 py-1.5 outline-none focus:border-[#C5A059]"
                >
                  {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
                <button data-testid={`booking-delete-${b.id}`} onClick={() => setConfirmId(b.id)} className="ml-auto text-[#A1A1AA] hover:text-red-400"><Trash2 size={16} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
      <Confirm open={!!confirmId} onClose={() => setConfirmId(null)} onConfirm={del} message="¿Eliminar esta reserva?" />
    </div>
  );
}
